import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const C = { purple:'#691FB1', purpleLight:'#C6C3E7', pink:'#FF357B', blue:'#57B1DD', txt:'#2b2b3a', soft:'#6b6b7b' };

const COMERCIAIS = [
  { nome:'Patrícia Silva', email:'patricia.silva@workwell.pt' },
  { nome:'Sara Batista',   email:'sara.batista@workwell.pt' },
  { nome:'Tânia Cunha',    email:'tania.cunha@workwell.pt' },
];
const CATS = [
  { id:'novas_vendas', label:'Novas vendas' },
  { id:'retencao',     label:'Retenção' },
  { id:'up_cross',     label:'Up / Cross' },
];
const MESES = ['Jan','Fev','Mar','Abr','Mai','Jun','Jul','Ago','Set','Out','Nov','Dez'];
const num = v => { const n = parseFloat(String(v).replace(',','.')); return isNaN(n)?0:n; };
const eur = n => (Number(n)||0).toLocaleString('pt-PT',{maximumFractionDigits:0})+' €';

function RetencaoPorCliente({ ano, podeEditar }){
  const [linhas, setLinhas] = React.useState([]);
  const [carregando, setCarregando] = React.useState(true);
  const [aberto, setAberto] = React.useState(null);
  const [msg, setMsg] = React.useState('');

  const carregar = React.useCallback(async ()=>{
    setCarregando(true);
    const { data } = await supabase.from('objetivos_retencao_cliente').select('*').eq('ano', ano).order('valor',{ascending:false});
    setLinhas(data||[]); setCarregando(false);
  },[ano]);
  React.useEffect(()=>{ carregar(); },[carregar]);

  // agrupar por comercial
  const porComercial = {};
  linhas.forEach(l=>{ (porComercial[l.comercial_nome] = porComercial[l.comercial_nome] || {nome:l.comercial_nome, email:l.comercial_email, contas:[], total:0}); porComercial[l.comercial_nome].contas.push(l); porComercial[l.comercial_nome].total += Number(l.valor)||0; });
  const comerciais = Object.values(porComercial).sort((a,b)=>b.total-a.total);
  const totalGeral = comerciais.reduce((s,c)=>s+c.total,0);
  const maxTotal = comerciais.reduce((m,c)=>Math.max(m,c.total),0)||1;

  const editarValor = async (id, novo)=>{
    const v = parseFloat(String(novo).replace(',','.'))||0;
    const { error } = await supabase.from('objetivos_retencao_cliente').update({valor:v}).eq('id',id);
    if(error){ setMsg('Erro ao guardar: '+error.message); } else { setMsg('Guardado.'); carregar(); }
    setTimeout(()=>setMsg(''),2500);
  };
  const adicionarConta = async (email, nome)=>{
    const cliente = window.prompt('Nome do cliente:'); if(!cliente||!cliente.trim()) return;
    const valorS = window.prompt('Valor de retenção anual (€):'); const valor = parseFloat(String(valorS||'').replace(',','.'))||0;
    const { error } = await supabase.from('objetivos_retencao_cliente').insert({comercial_email:email, comercial_nome:nome, cliente:cliente.trim(), valor, ano});
    if(error){ setMsg('Erro: '+error.message); } else { setMsg('Conta adicionada.'); carregar(); }
    setTimeout(()=>setMsg(''),2500);
  };
  const removerConta = async (id, cliente)=>{
    if(!window.confirm('Remover a conta "'+cliente+'"?')) return;
    const { error } = await supabase.from('objetivos_retencao_cliente').delete().eq('id',id);
    if(error){ setMsg('Erro: '+error.message); } else { setMsg('Conta removida.'); carregar(); }
    setTimeout(()=>setMsg(''),2500);
  };

  if(carregando) return <div style={{ color:C.soft, fontSize:13, padding:'10px 0' }}>A carregar retenção…</div>;
  if(comerciais.length===0) return <div style={{ color:C.soft, fontSize:13, padding:'10px 0' }}>Sem retenção carregada para {ano}.</div>;

  return (
    <div style={{ marginTop:32 }}>
      <div style={{ display:'flex', alignItems:'baseline', justifyContent:'space-between', flexWrap:'wrap', gap:8, marginBottom:6 }}>
        <h2 style={{ margin:0, fontSize:20, color:C.purple }}>🛡️ Retenção por Cliente · {ano}</h2>
        <div style={{ fontSize:14, color:C.soft }}>Total: <b style={{ color:C.txt }}>{eur(totalGeral)}</b></div>
      </div>
      {msg && <div style={{ background:msg.startsWith('Erro')?'#FDECEC':'#E8F8EF', color:msg.startsWith('Erro')?'#B0322B':'#1B7A48', padding:'6px 10px', borderRadius:8, fontSize:12, margin:'6px 0', fontWeight:600 }}>{msg}</div>}
      {comerciais.map(c=>(
        <div key={c.nome} style={{ background:'#fff', border:'1px solid '+C.purpleLight, borderRadius:12, padding:'14px 16px', marginBottom:12 }}>
          <div onClick={()=>setAberto(aberto===c.nome?null:c.nome)} style={{ display:'flex', alignItems:'center', gap:12, cursor:'pointer' }}>
            <span style={{ color:C.purple, fontSize:13 }}>{aberto===c.nome?'▾':'▸'}</span>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'baseline', justifyContent:'space-between', gap:8, flexWrap:'wrap' }}>
                <span style={{ fontSize:15, fontWeight:800, color:C.purple }}>{c.nome}</span>
                <span style={{ fontSize:14, fontWeight:800, color:C.txt }}>{eur(c.total)}</span>
              </div>
              <div style={{ height:8, background:'#EEE9F7', borderRadius:6, marginTop:6, overflow:'hidden' }}>
                <div style={{ height:'100%', width:(c.total/maxTotal*100)+'%', background:C.purple, borderRadius:6 }}/>
              </div>
              <div style={{ fontSize:11, color:C.soft, marginTop:3 }}>{c.contas.length} conta(s) · {(c.total/totalGeral*100).toFixed(1)}% do total</div>
            </div>
          </div>
          {aberto===c.nome &&
            <div style={{ marginTop:12, borderTop:'1px solid '+C.purpleLight, paddingTop:10 }}>
              {c.contas.map(ct=>(
                <div key={ct.id} style={{ display:'flex', alignItems:'center', gap:10, padding:'5px 0', borderBottom:'1px solid #F3F0FA' }}>
                  <span style={{ flex:1, fontSize:13, color:C.txt }}>{ct.cliente}</span>
                  {podeEditar ? (
                    <>
                      <input type="number" defaultValue={ct.valor} onBlur={e=>{ if(parseFloat(e.target.value)!==Number(ct.valor)) editarValor(ct.id, e.target.value); }} style={{ width:110, padding:'5px 8px', border:'1px solid '+C.purpleLight, borderRadius:6, fontSize:13, textAlign:'right', fontFamily:"'DM Sans',sans-serif" }}/>
                      <span style={{ fontSize:13, color:C.soft }}>€</span>
                      <button onClick={()=>removerConta(ct.id, ct.cliente)} style={{ background:'none', border:'none', color:'#C0392B', cursor:'pointer', fontSize:13 }}>✕</button>
                    </>
                  ) : (
                    <span style={{ fontSize:13, fontWeight:700, color:C.txt }}>{eur(ct.valor)}</span>
                  )}
                </div>
              ))}
              {podeEditar && <button onClick={()=>adicionarConta(c.email, c.nome)} style={{ background:C.purpleLight, color:C.purple, border:'none', borderRadius:7, padding:'6px 12px', fontSize:12, cursor:'pointer', fontWeight:700, marginTop:10, fontFamily:"'DM Sans',sans-serif" }}>+ Adicionar conta</button>}
            </div>}
        </div>
      ))}
    </div>
  );
}

export default function ObjetivosView({ voltar }){
  const anoAtual = new Date().getFullYear();
  const [ano, setAno] = useState(anoAtual);
  const [vals, setVals] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');
  const [aberto, setAberto] = useState(null);

  useEffect(()=>{
    let active = true;
    (async()=>{
      setLoading(true);
      const { data } = await supabase.from('objetivos').select('*').eq('ano', ano);
      if(!active) return;
      const m = {};
      (data||[]).forEach(o => { m[o.comercial_email+'|'+o.categoria+'|'+(o.mes||0)] = String(o.valor||''); });
      setVals(m); setLoading(false);
    })();
    return ()=>{ active=false; };
  },[ano]);

  const setVal = (email, cat, mes, v) => setVals(p => ({ ...p, [email+'|'+cat+'|'+mes]: v }));
  const get = (email, cat, mes) => vals[email+'|'+cat+'|'+mes] || '';
  const somaMensais = (email) => { let s=0; for(let m=1;m<=12;m++) s+=num(get(email,'total',m)); return s; };
  const novasVendasEfetivo = (email) => { const sm=somaMensais(email); return sm>0 ? sm : num(get(email,'novas_vendas',0)); };
  const totalAnual = (email) => novasVendasEfetivo(email) + CATS.filter(cat=>cat.id!=='novas_vendas').reduce((s,cat)=> s + num(get(email,cat.id,0)), 0);
  const totalEmpresa = COMERCIAIS.reduce((s,c)=> s + totalAnual(c.email), 0);

  async function guardar(){
    setSaving(true); setMsg('');
    const rows = [];
    for (const c of COMERCIAIS){
      for (const cat of CATS){
        const v = cat.id==='novas_vendas' ? novasVendasEfetivo(c.email) : num(get(c.email,cat.id,0));
        if (v>0) rows.push({ comercial_email:c.email, comercial_nome:c.nome, ano, mes:null, categoria:cat.id, valor:v });
      }
      for (let mth=1; mth<=12; mth++){
        const v = num(get(c.email,'total',mth));
        if (v>0) rows.push({ comercial_email:c.email, comercial_nome:c.nome, ano, mes:mth, categoria:'total', valor:v });
      }
    }
    const { error:delErr } = await supabase.from('objetivos').delete().eq('ano', ano).in('comercial_email', COMERCIAIS.map(c=>c.email));
    if (delErr){ setMsg('Erro: '+delErr.message); setSaving(false); return; }
    if (rows.length){
      const { error:insErr } = await supabase.from('objetivos').insert(rows);
      if (insErr){ setMsg('Erro ao guardar: '+insErr.message); setSaving(false); return; }
    }
    setMsg('Objetivos guardados ✓'); setSaving(false);
    setTimeout(()=>setMsg(''), 3000);
  }

  const inp = { width:'100%', padding:'7px 9px', borderRadius:7, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt, boxSizing:'border-box', textAlign:'right' };
  const lbl = { fontSize:11, color:C.soft, fontWeight:700, textTransform:'uppercase', letterSpacing:'.04em', marginBottom:3, display:'block' };

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", color:C.txt, padding:'24px 32px', boxSizing:'border-box', width:'100%' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:8, flexWrap:'wrap', gap:10 }}>
        <div style={{ display:'flex', alignItems:'center', gap:12 }}>
          <button onClick={voltar} style={{ background:C.purpleLight, color:C.purple, border:'1px solid '+C.purple, borderRadius:8, padding:'7px 13px', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>← Voltar</button>
          <h2 style={{ margin:0, fontSize:20, color:C.purple }}>🎯 Objetivos</h2>
        </div>
        <div style={{ display:'flex', alignItems:'center', gap:10 }}>
          <select value={ano} onChange={e=>setAno(parseInt(e.target.value))} style={{ padding:'8px 12px', borderRadius:8, border:'1px solid '+C.purpleLight, fontSize:13, fontFamily:"'DM Sans',sans-serif", color:C.txt }}>
            {[anoAtual-1, anoAtual, anoAtual+1].map(y=><option key={y} value={y}>{y}</option>)}
          </select>
          <button onClick={guardar} disabled={saving} style={{ background:saving?C.soft:C.purple, color:'#fff', border:'none', borderRadius:8, padding:'9px 18px', fontSize:13, cursor:'pointer', fontFamily:"'DM Sans',sans-serif", fontWeight:700 }}>{saving?'A guardar…':'Guardar'}</button>
        </div>
      </div>
      <p style={{ color:C.soft, fontSize:13, margin:'0 0 4px' }}>Metas anuais por categoria. Se preencheres metas mensais, o "Novas vendas (anual)" passa a refletir automaticamente a soma delas. Mês vazio → o dashboard divide o anual por 12.</p>
      {msg && <div style={{ background:msg.startsWith('Erro')?'#FDECEC':'#E8F8EF', color:msg.startsWith('Erro')?'#B0322B':'#1B7A48', padding:'8px 12px', borderRadius:8, fontSize:13, margin:'8px 0', fontWeight:600 }}>{msg}</div>}

      <div style={{ background:C.purpleLight, borderRadius:12, padding:'14px 20px', margin:'14px 0', display:'inline-block', minWidth:240 }}>
        <div style={{ fontSize:12, color:C.purple, fontWeight:700 }}>OBJETIVO TOTAL EMPRESA · {ano}</div>
        <div style={{ fontSize:24, fontWeight:800, color:C.purple }}>{eur(totalEmpresa)}</div>
      </div>

      {loading ? <p style={{ color:C.soft }}>A carregar…</p> :
      COMERCIAIS.map(c=>(
        <div key={c.email} style={{ background:'#fff', border:'1px solid '+C.purpleLight, borderRadius:12, padding:'16px 18px', marginBottom:14 }}>
          <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:12, flexWrap:'wrap', gap:8 }}>
            <div style={{ fontSize:16, fontWeight:800, color:C.purple }}>{c.nome}</div>
            <div style={{ fontSize:13, color:C.soft }}>Total anual: <b style={{ color:C.txt }}>{eur(totalAnual(c.email))}</b></div>
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(160px, 1fr))', gap:12 }}>
            {CATS.map(cat=>{
              const derivado = cat.id==='novas_vendas' && somaMensais(c.email)>0;
              return (
                <div key={cat.id}>
                  <label style={lbl}>{cat.label} (anual)</label>
                  {derivado ? (
                    <>
                      <input type="text" value={somaMensais(c.email).toLocaleString('pt-PT')} readOnly
                        style={{ ...inp, background:'#F4F1FB', color:C.purple, fontWeight:700, cursor:'default' }}/>
                      <div style={{ fontSize:10, color:C.soft, marginTop:2 }}>= soma das metas mensais</div>
                    </>
                  ) : (
                    <input type="number" min="0" step="100" value={get(c.email,cat.id,0)} onChange={e=>setVal(c.email,cat.id,0,e.target.value)} style={inp} placeholder="0"/>
                  )}
                </div>
              );
            })}
          </div>
          <button onClick={()=>setAberto(aberto===c.email?null:c.email)} style={{ background:'none', border:'none', color:C.purple, cursor:'pointer', fontSize:13, fontWeight:700, marginTop:12, padding:0, fontFamily:"'DM Sans',sans-serif" }}>
            {aberto===c.email?'▾':'▸'} Metas mensais (opcional)
          </button>
          {aberto===c.email &&
            <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(90px, 1fr))', gap:10, marginTop:10 }}>
              {MESES.map((mn, i)=>(
                <div key={mn}>
                  <label style={lbl}>{mn}</label>
                  <input type="number" min="0" step="100" value={get(c.email,'total',i+1)} onChange={e=>setVal(c.email,'total',i+1,e.target.value)} style={inp} placeholder="—"/>
                </div>
              ))}
            </div>}
        </div>
      ))}
      <RetencaoPorCliente ano={ano} podeEditar={true} />
    </div>
  );
}
